<template>
  <div>
    <!-- {{file_repository_id}} -->
   
    <vs-button
      style="display: inline-flex; float: left"
      class="mb-2"
      color="primary"
      type="filled"
      icon="menu"
      @click.prevent="switchTheme"
    >
      <span v-if="theme != 'list'">List View</span>
      <span v-if="theme == 'list'">Grid View</span>
    </vs-button>
    <!-- <vs-tooltip
      text="Import File From Your Existing System"
      style="display: inline-flex; float: right"
    >
      <vs-button
        class="mb-2 ml-2"
        color="primary"
        type="filled"
        icon="file_upload"
        @click="isBrowseContent = true"
        >Files</vs-button
      >
    </vs-tooltip> -->

    <vs-tooltip style="display: inline-flex; float: right" class="inline-block align-bottom" color="primary" text="Import Google Drive files"> 
    <!-- <pre>{{file_id_payload}}</pre> -->
      <vs-button
        class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
        color="primary"
        type="border"
        @click="driveIconClicked()"
        >
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
      </vs-button>
    </vs-tooltip>

    <!-- <vs-button
      style="display: inline-flex; float: right"
      class="mb-2"
      color="dark"
      type="filled"
      icon="close"
      @click.prevent="hideFileUploader"
    >
    </vs-button> -->

    <vs-divider />
    <!-- {{acceptedfileUploadType}}
    {{accept}} -->
    <!-- {{ fileRecords }} -->
    <VueFileAgent
      ref="vueFileAgent"
      :accept="imagevalidation"
      :auto="auto"
      :theme="theme"
      :multiple="multipleSelect"
      :deletable="true"
      :meta="true"
      :maxSize="'10000MB'"
      :maxFiles="14"
      :helpText="helpText"
      :errorText="{
        type: 'Invalid file type. Only images or zip Allowed',
        size: 'Files should not exceed 10MB in size',
      }"
      @select="filesSelected($event)"
      @beforedelete="onBeforeDelete($event)"
      @delete="fileDeleted($event)"
      v-model="fileRecords"
      @upload:error="uploadEvent('upload:error', $event)"
    ></VueFileAgent>

    <div v-if="fileRecordsForUpload.length">
      <vs-divider />
      <vs-button
        :disabled="!fileRecordsForUpload.length"
        @click="uploadFiles()"
      >
        Upload {{ fileRecordsForUpload.length }} {{ fileRecordsForUpload.length > 1 ? 'files' : 'file' }}
      </vs-button>
    </div>

    <vs-divider />
  </div>
</template>

<script>

// import { getUploadedFilesId } from '@/api/assignment-question'
import {getUploadedFilesId} from '@/api/course/courseapi'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'

export default {
  name: 'VueFileAgentComponent',
  components: { ImportBrowseFilesModel },
  mixins:[GoogleAuthorization],
  props: {
    question_detail_obj: {},
    question_detail_index: {},
    acceptedfileUploadType: {},
    helpText: {},
    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    },
    filesInfo: {
      required: false,
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    acceptFiles: {
      type: String,
      default: ''
    },
    acceptGDriveFiles: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      multipleSelect: this.multiple,
      isBrowseContent: false,
      theme: 'grid',
      auto: true,
      fileRecords: [],
      imagevalidation: this.acceptFiles,
      fileTypeValidation: this.acceptGDriveFiles,
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [], // maintain an upload queue
      accept: ''
    }
  },
  // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

  created () {
    /* if (this.filesInfo.length) {


      this.fileRecords = this.filesInfo.map((ele) => {
        return {
          name: ele.file_name,
          sizeText: this.bytesToSize(ele.size),
          size: ele.size,
          type: ele.file_type,
          url: ele.file_path,
          upload: {
            data: true,
            error: false
          }
        }
      })
      // this.accept = this.acceptedfileUploadType

    } */
    //
    const customer_id = localStorage.getItem('customer_id')
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${localStorage.getItem('token')}`
  },
  mounted () {
    setTimeout(() => {
    }, 1000)
  },
  watch:{
    acceptedfileUploadType () {
      this.accept = this.acceptedfileUploadType
    },
    filesInfo: {
      deep: true,
      immediate: true,
      handler () {
        if (this.filesInfo.length > 0) {
          this.fileRecords =  this.filesInfo.map((ele) => {
            return {
              'name':ele.file_name,
              'sizeText':this.bytesToSize(ele.size),
              'size':ele.size,
              'type':ele.file_type,
              'url':ele.file_path
            }
          })
        }
      }
    }
  },
  methods: {
    hideFileUploader () {
      this.$emit('hideFileUploader')
    },
    switchTheme () {
      this.theme = this.theme === 'list' ? 'default' : 'list'
    },
    uploadEvent (eventName, data) {

    },
    uploadFiles () {


      // Using the default uploader. You may use another uploader instead.
      // const data = this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload)

      //

      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {


          const formData = new FormData()
          formData.append('files[]', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )


      this.$vs.loading({
        type: 'material',
        text: `Please wait we are uploading ${this.fileRecordsForUpload.length > 1 ? 'files' : 'file' }`
      })

      data
        .then((response, error) => {

          const cdn = response[0].data.data.cdn
          if (response) {

            for (let i = 0; i < response.length; i++) {
              const file_name = response[i].data.data.files[0].file_name
              const file_path = response[i].data.data.files[0].file_path

            
              const raw = JSON.stringify({
                file_repository_id: this.file_repository_id,
                files: [
                  {
                    file_name,
                    file_path: `${cdn}${file_path}`
                  }
                ]
              })

              const file_id_payload = raw
              console.log(file_id_payload)

              this.getUploadFiles(file_id_payload)
            }
          } else {

            this.$vs.loading.close()
          }
        })
        .catch((error) => {
          this.$vs.loading.close()


        })
        .finally(this.$vs.loading.close())
      this.fileRecordsForUpload = []
    },

    filesSelected (fileRecordsNewlySelected) {

      const validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      )

      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      )
    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this file?',
          accept: this.acceptAlert,
          parameters: fileRecord
        })
      }
    },
    acceptAlert (fileRecord) {
      const index = this.fileRecords.indexOf(fileRecord)

      this.deletedIndex = index


      this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event

      // this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
    },
    fileDeleted (fileRecord) {
      console.log('Files')
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    },
    deleteUploadedFile (fileRecord) {
      console.log('Files1')
      const fileIdObject = {
        question_detail_index: this.question_detail_index,
        fileIndex: this.deletedIndex
      }
      console.log(fileIdObject)
      this.$emit('deletedIndex', fileIdObject)

    },

    //custom function for getting upload file

    async getUploadFiles (file_id_payload, type = 'system') {
      try {
        const res = await getUploadedFilesId(file_id_payload)
        console.log(res)

        if (res.data.message === 'files.createFile') {
          //this.$emit('getFileId', res.data.data.files[0].files_id)
          const fileIdObject = {
            question_index: this.question_detail_index,
            file_id: res.data.data.files[0].files_id
          }

          //this.$emit('getFileId', fileIdObject)

          const fileObject = {
            files_id:res.data.data.files[0].files_id,
            files_repository_id:this.file_repository_id,
            file_image_url:res.data.data.files[0].file_path

          }

          const filesDriveInfo = res.data.data.files
          console.log(filesDriveInfo)
          let filesDrive = []
        
    
          if (type === 'drive') {
            
            filesDrive = filesDriveInfo.map(ele => {
              return {
                name: ele.file_name,
                sizeText: this.bytesToSize(ele.size),
                size: ele.size,
                type: ele.file_type,
                url: ele.file_path,
                color: 'green',
                upload: {
                  data: true,
                  error: false
                }
              }
            })
            console.log(filesDriveInfo)

            if (this.multiple) {
              this.fileRecords.push(...filesDrive)
            } else {
              this.fileRecords = filesDrive
            }
            

            console.log(filesDrive)
            const repo_id = this.files_repository_id
            console.log(repo_id)
            filesDriveInfo.forEach(ele => {
              console.log(repo_id)
              console.log(ele)
 
              this.$emit('getImage', {
                files_id:ele.files_id,
                files_repository_id:this.file_repository_id,
                file_image_url:ele.file_path
              })

              const fileIdObject = {
                question_index: this.question_detail_index,
                file_id: ele.files_id
              }

              this.$emit('getFileId', fileIdObject)

            })
            this.$vs.notify({
              title: 'Success',
              text: 'File Uploaded Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 1000
            })
          } else {
            this.$emit('getImage', fileObject)
            this.$emit('getFileId', fileIdObject)
          }   
          this.$vs.loading.close()
        }
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
      /* const res = await getUploadedFilesId(file_id_payload)
      console.log(res)

      if (res.data.message === 'files.createFile') {
        const file_id = res.data.data.files[0].files_id
        this.$vs.notify({
          title: 'Success',
          text: 'File uploaded successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })


        const fileIdObject = {
          question_index: this.question_detail_index,
          file_id
        }

        this.$vs.loading.close()

        this.$emit('getFileId', fileIdObject)
      } */
    },
    getImportFile ({ file_id, fileInfo }) {

      const fileObject = {
        question_index: this.question_detail_index,
        file_id
      }
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)

      const importFileRecords = this.getImportedFile(fileInfo)

      this.filesInfo.push(
        ...importFileRecords.map((ele) => {
          return {
            file: {
              file_name: ele.name,
              file_path: ele.url,
              size: ele.size,
              file_type: ele.type
            }
          }
        })
      )

      this.fileRecords.push(...importFileRecords)
      this.$emit('getFileId', fileObject)
    },
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
    getImportedFile (fileInfo) {
      return fileInfo.map((ele) => {
        return {
          name: ele.file_name,
          sizeText: this.bytesToSize(ele.size),
          size: ele.size,
          type: ele.file_type,
          url: ele.file_path,
          color: 'green',
          upload: {
            data: true,
            error: false
          }
        }
      })
    }

    //custom function for getting upload files
  }
}
</script>
